import { RouteName } from '@/router/models/route-name';
import { reactive, toValue, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import type { Ata, UseAtaTableInvoicingOkLogicProps } from '../types';
import { createAtaTableInvoicingOkStore } from './createAtaTableInvoicingOkStore';

export type { UseAtaTableInvoicingOkLogicProps };

type UseAtaTableInvoicingOkLogicReturn = {
  state: { atas: Ata[] };
  action: { select: (ata: Ata) => void };
};

export const useAtaTableInvoicingOkLogic = (
  props: UseAtaTableInvoicingOkLogicProps,
): UseAtaTableInvoicingOkLogicReturn => {
  const router = useRouter();
  const store = createAtaTableInvoicingOkStore(props.initialAtas);

  watchEffect(() => {
    store.dispatch({ type: 'reset', payload: props.initialAtas });
  });

  const action = {
    select: (ata: Ata): void => {
      router.push({
        name: RouteName.ATADetails,
        params: { id: toValue(props.projectId), ataId: ata.id },
      });
    },
  };

  return {
    state: reactive({ atas: store.atas }),
    action,
  };
};
